import {  Navigate , Outlet } from "react-router-dom";
import useAuth from "../hook/useAuth";

const NoAuth=() =>{
    const ctx = useAuth(); 
    return (
        (ctx?.username !=="" && ctx?.username !==null) ? <Navigate to="/"  replace/>  : <Outlet/>
    )
}

export default NoAuth;
